module.exports = __webpack_public_path__ + "static/media/question-mark.2e541755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question-mark.svg
// module id = 161
// module chunks = 0